import React from 'react';
import PropTypes from 'prop-types';

export default class DebuggableComponent extends React.Component {
    renderContent() {
        throw new Error(
            '[Seatlib] renderContent was not overwritten. Did you extend DebuggableComponent and used Component.render?',
        );
    }

    debug(...args) {
        this.props.debug &&
      console.log(`[Seatlib][${this.constructor.name}]`, ...args);
    }

    time(tag) {
        this.props.debug && console.time(tag);
    }

    timeEnd(tag) {
        this.props.debug && console.timeEnd(tag);
    }

    render() {
        if (this.props.debug) {
            const tag = `[Seatlib] Rendering ${this.constructor.name}`;
            console.time(tag);
            let render = this.renderContent();
            console.timeEnd(tag);
            return render;
        } else {
            return this.renderContent();
        }
    }
}

DebuggableComponent.defaultProps = {
    debug: false,
};

DebuggableComponent.propTypes = {
    debug: PropTypes.bool,
};
